import { Operador } from "../../../layout/encuestas/encuestas-detalle/editor-condiciones/clases/Operador";
import { TipoOperadorEnum } from "@shared/enums";


export const operadores = [
    new Operador("Y", "&"),
    new Operador("O", "|"),
    new Operador("No", "~", TipoOperadorEnum.UNARIO)
];
